/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AuditLevelType = {
    System: 'System',
    Admin: 'Admin',
    User: 'User'
} as const;
export type AuditLevelType = typeof AuditLevelType[keyof typeof AuditLevelType];

